import { Routes } from "@angular/router";
import { DownloadMobileAppComponent } from "./download-mobile-app.component";

export const downloadMobileAppRoutes: Routes = [
  {
    path: "",
    component: DownloadMobileAppComponent,
  },
];
